import type { DateTime } from 'luxon';

export class SignHelper {
  static signAndCollectTimesExpired(signTime: DateTime | null | undefined, collectTime: DateTime | null | undefined, compareTo: DateTime): boolean {
    const signTimeExpired = !!signTime && compareTo.diff(signTime, 'minutes').minutes > 5;
    const collectTimeExpired = !!collectTime && compareTo.diff(collectTime, 'seconds').seconds > 10;

    return signTimeExpired || collectTimeExpired;
  }
}
